import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Main from "Pages/Main";
import BankHistory from "Pages/BankHistory";
import LoginPage from "Pages/LoginPage";
import PendingPage from "Pages/PendingPage";
import AdminPage from "Pages/AdminPage";
import ProtectedRoute from "Components/ProtectedRoute";

function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/pending" element={<PendingPage />} />

        <Route element={<ProtectedRoute allowedRoles={[0, 2]} fallbackPath="/premium" />}>
          <Route path="/" element={<Main />} />
          <Route path="/bank" element={<BankHistory />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={[1, 2]} fallbackPath="/" />}>
          <Route path="/premium" element={<Main />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={[2]} fallbackPath="/" />}>
          <Route path="/admin" element={<Main />} />
          <Route path="/manage" element={<AdminPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default Router;